/**
 * This component is a wrapper around the App Bridge `ui-title-bar` element.
 * It is used to to populate the app title bar with button actions or the
 * modal header and footer when used within the Modal component.
 *
 * @see {@link https://shopify.dev/docs/api/app-bridge-library/react-components/titlebar}
 */
const TitleBar = 'ui-title-bar';

export { TitleBar };
